import React from "react";
import { connect } from "react-redux";
import { bindInstance } from "redux-mvc";
import { showModal, hideModal } from "redux/modules/modal/actions";
import { Div, BigFilledButton, BigOutlineButton } from "components/Base";
import SendInductionFormModal from "EventLight/Common/SendInductionFormModal";
import OverrideInductionFormModal from "EventLight/Common/OverrideInductionFormModal";
import ModalWrapper from "components/Global/Modal/Wrappers/Black";
import StyleWrapper from "components/Global/Modal/Layout/StyleWrapper";
import { eventId as getEventId } from "redux/modules/event/selectors";

const decorate = connect(
  state => ({
    eventId: getEventId(state)
  }),
  bindInstance({
    showModal,
    hideModal
  })
);

const InductionFormWarning = ({
  contactId,
  contactName,
  showModal,
  hideModal,
  eventId,
  onDone
}) => {
  const resendInductionForm = () => {
    showModal({
      content: (
        <SendInductionFormModal
          selectedContactIds={[contactId]}
          closeModal={hideModal}
          eventId={eventId}
          fetchData={onDone}
          resendTo={contactName}
        />
      ),
      wrapper: ModalWrapper
    });
  };

  const handleOverrideForm = () => {
    showModal({
      content: (
        <OverrideInductionFormModal
          contactIds={[contactId]}
          closeModal={hideModal}
          eventId={eventId}
          fetchData={onDone}
          contactName={contactName}
        />
      ),
      wrapper: ModalWrapper
    });
  };

  return (
    <StyleWrapper
      heading={`Issuing items to ${contactName ? contactName : "Contact"}`}
      width={500}
      bodyStyles={{ padding: 0 }}
    >
      <Div display="column" alignItems="center" p={6}>
        <Div fs={3} mb={4} color="gray7">
          <strong>{contactName}</strong> has not completed the Induction Form.
        </Div>
        <Div display="row" width={1} style={{ display: "flex", gap: 10 }}>
          <BigOutlineButton width={1} onClick={handleOverrideForm}>
            Override
          </BigOutlineButton>
          <BigFilledButton width={1} onClick={resendInductionForm} bg="altB5">
            Re-send Form
          </BigFilledButton>
        </Div>
      </Div>
    </StyleWrapper>
  );
};

export default decorate(InductionFormWarning);
